function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 0.2em;\n  align-items: flex-end;\n\n  &:nth-child(2) {\n    margin-top: 0.3em;\n    font-size: 1.3em;\n    align-items: flex-start;\n\n    & > * {\n      animation-direction: reverse;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  opacity: 0.4;\n  font-size: 1em;\n  animation: ", " 8s linear infinite;\n\n  &:nth-child(2) {\n    font-size: 1.5em;\n    opacity: 0.6;\n    margin-top: -0.1em;\n    animation: ", " 8s linear infinite reverse;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import Spin from './animations/Spin';
import { ThemePropType, defaultTheme } from '../constants';
var Flake = styled.div.attrs({
  'data-e2e': 'flake',
  'data-animation': true
})(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.snowColor;
}, Spin, Spin);
Flake.propTypes = {
  theme: ThemePropType
};
Flake.defaultProps = {
  theme: defaultTheme
};
var FlakesContainer = styled.div(_templateObject2());

var Flakes = function Flakes() {
  return /*#__PURE__*/React.createElement(FlakesContainer, null, /*#__PURE__*/React.createElement(Flake, null, "\u2744"), /*#__PURE__*/React.createElement(Flake, null, "\u2744"));
};

Flakes.displayName = 'Flakes';
export default Flakes;